(function (algolia) {
  'use strict';

  algolia.translations = {
    search: "Aktuelle Suche",
    noCollectionFound: "Es wurden keine Kategorien gefunden",
    allProducts: "Alle Produkte ansehen",
    matching: "übereinstimmend",
    sortBy: "Sortiert nach",
    relevance: "Relevanz",
    outOf: "von",
    resultsFound: "gefundenen Ergebnissen",
    oneResultFound: "1 gefundemem Ergebniss",
    noResultFound: "Keine Ergebnisse gefunden",
    addToCart: "Zum Warenkorb hinzufügen",
    searchForProduct: "Weine, Bodegas, Weiß, Rot, Rosé...",
    selectedFilter: "Ausgewählte Filter",
    clearAll: "Zurücksetzen",
    noPageFound: "Seite nicht gefunden",
    outOfStock: "Zur Zeit nicht verfügbar!",
  };

  algolia.translation_helpers = {
    no_result_for: function (text, render) {
      return 'Keine Ergebnisse gefunden für ' + render(text) + '';
    },
    in: function (text, render) {
      return 'in ' + render(text) + 's';
    },

    try_clear_or_change_input: function (text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return 'Try ' + render(html_tags[0]) + ' clearing filters ' + render(html_tags[1]) + ' or ' + render(html_tags[2]) + ' changing your input ' + render(html_tags[3]) + '';
    },
    outOf: function (text, render) {
      return '' + render(text) + ' von';
    },

    by: function (text, render) {
      return 'nach ' + render(text) + '';
    }
  };

}(algoliaShopify));
